import { type Tag, type SingleQuestionProperties } from '@exam-management/graphql';

function getTotalQuestionByLevelItemId(
  singleQuestionProperties: SingleQuestionProperties[] | undefined,

  difficultyCategoryId: string,
  calculationCategoryId: string,
) {
  if (!singleQuestionProperties) return null;
  const totalQuestions = singleQuestionProperties.find((property) => {
    const hasDifficultyTag = property.tags.some((tag) => tag.id === difficultyCategoryId);

    const hasCalculationTag = property.tags.some((tag) => tag.id === calculationCategoryId);
    return hasDifficultyTag && hasCalculationTag;
  });
  return totalQuestions?.totalQuestions ?? null;
}
export function formatDataToQuestionSummaryWithMap(input: {
  questionGroups?: SingleQuestionProperties[];
  difficultyTags: Tag[];
  calculationTags: Tag[];
}) {
  const { questionGroups, difficultyTags, calculationTags } = input;

  const difficultyMap = {
    hard: difficultyTags.find((t) => t.name === 'ยาก')?.id ?? '',
    medium: difficultyTags.find((t) => t.name === 'กลาง')?.id ?? '',
    easy: difficultyTags.find((t) => t.name === 'ง่าย')?.id ?? '',
  };

  const calculationMap = {
    calculate: calculationTags.find((t) => t.name === 'คำนวณ')?.id ?? '',
    nonCalculate: calculationTags.find((t) => t.name === 'ไม่คำนวณ')?.id ?? '',
  };

  return {
    calculate: {
      hardQuestions: getTotalQuestionByLevelItemId(
        questionGroups,
        difficultyMap.hard,
        calculationMap.calculate,
      ),
      mediumQuestions: getTotalQuestionByLevelItemId(
        questionGroups,
        difficultyMap.medium,
        calculationMap.calculate,
      ),
      easyQuestions: getTotalQuestionByLevelItemId(
        questionGroups,
        difficultyMap.easy,
        calculationMap.calculate,
      ),
    },
    nonCalculate: {
      hardQuestions: getTotalQuestionByLevelItemId(
        questionGroups,
        difficultyMap.hard,
        calculationMap.nonCalculate,
      ),
      mediumQuestions: getTotalQuestionByLevelItemId(
        questionGroups,
        difficultyMap.medium,
        calculationMap.nonCalculate,
      ),
      easyQuestions: getTotalQuestionByLevelItemId(
        questionGroups,
        difficultyMap.easy,
        calculationMap.nonCalculate,
      ),
    },
    total: questionGroups?.reduce((sum, item) => sum + item.totalQuestions, 0) ?? 0,
  };
}
